<template>
    <div class="job-board-empty">
        <div class="job-board-empty-card">
            <div>No Results Found</div>
            <Btn route to="/">Back to All Results</Btn>
        </div>
    </div>
</template>

<script>
import Btn from '@/components/Btn.vue'

export default {
    name: 'JobBoardListEmpty',
    components: {
        Btn
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    @import "../scss/vars";

    .job-board-empty{
        margin: 3rem 0;

        &-card{
            background-color: white;
            border-radius: $radius;
            max-width: $b1 / 2;
            margin: 0 auto;
            text-align: center;
            padding: 3rem;
        }
    }
</style>